<template>
	<div class="omapi-input__multiselect">
		<label v-if="label">{{ label }}</label>
		<multiselect
			:value="optionValue"
			@input="setValue"
			:options="options"
			:multiple="multiple"
			:loading="loading"
			:placeholder="searchPlaceholder"
			:showLabels="false"
			openDirection="bottom"
			:label="optionsLabelField"
			track-by="value"
			:class="{
				'multiselect__has-value': hasValue,
				'multiselect__is-loading': loading,
				'multiselect__nooptions': !options.length,
			}"
			v-bind="$attrs"
			v-on="$listeners"
			ref="multiselect"
		>
			<template v-slot:placeholder>{{ placeholder }}</template>
			<template v-slot:clear>
				<div
					v-show="hasValue"
					class="omapi-input__multiselect-close-all"
					@click="clear"
				>
					<img src="../../../assets/images/icons/card-close.svg" alt="Clear Select">
				</div>
			</template>
			<template v-slot:noOptions><slot name="noOptions">List is empty.</slot></template>
			<template v-slot:afterList><slot name="afterList"></slot></template>
		</multiselect>
	</div>
</template>

<script>
import get from 'lodash/get'
import Multiselect from 'vue-multiselect'

export default {
	inheritAttrs : false,
	components   : { Multiselect },
	props        : {
		label : {
			type    : String,
			default : '',
		},
		placeholder : {
			type    : String,
			default : 'Type to search...',
		},
		searchPlaceholder : {
			type    : String,
			default : '',
		},
		options : {
			type     : Array,
			required : true,
		},
		multiple : {
			type    : Boolean,
			default : false,
		},
		loading : {
			type    : Boolean,
			default : false,
		},
		value             : [ Array, String, Number, Object ],
		optionsLabelField : {
			type    : String,
			default : 'name',
		},
	},
	computed : {
		optionValue () {
			const selected = this.value
				? this.options.filter(o => this.selected(o.value))
				: []

			return selected
		},
		hasValue () {
			return this.optionValue.length
		},
	},
	methods : {
		selected (value) {
			const current = this.multiple
				? this.value
				: this.$get('value.value', this.value)

			return this.multiple
				? current.includes(value)
				: current === value
		},
		setValue (selected) {
			selected = this.multiple
				? selected.map(v => v.value)
				: get(selected, 'value', selected || '')

			this.$emit('input', selected, this.$attrs)
		},
		clear () {
			this.$emit('input', this.multiple ? [] : '', this.$attrs)
		},
	},
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
	.omapi-multi-select-input {
		text-align: left;
		margin-bottom: 10px;
	}
</style>
